import { Title } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  isLoggedIn: boolean
}

export const Header = ({ isLoggedIn }: Props) => {
  const description = isLoggedIn
    ? undefined
    : i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.login.description.main'
      )
  return (
    <Title
      title={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.login.title'
      )}
      description={description}
    />
  )
}
